import { BrandLogo } from "./components/BrandLogo";
import { CallRequestForm } from "./components/CallRequestForm";
import { StatusView } from "./components/StatusView";
import { SuccessState } from "./components/SuccessState";
import { PRESET_STYLES, resolveUiPreset } from "./config/presets";
import { useCallRequest } from "./hooks/useCallRequest";
import { useExternalAssets } from "./hooks/useExternalAssets";
import { usePageParams } from "./hooks/usePageParams";

const isInIframe = (): boolean => {
	try {
		return window.self !== window.top;
	} catch {
		return true;
	}
};

export default function App() {
	const preset = resolveUiPreset();
	const styles = PRESET_STYLES[preset];
	const inIframe = isInIframe();
	const {
		urlParams,
		isValidPage,
		backgroundColorOverride,
		logoUrl,
		headingOverride,
	} = usePageParams();
	const {
		formData,
		submitted,
		wasMessageSubmission,
		isLoading,
		error,
		onFieldChange,
		onSubmit,
	} = useCallRequest(urlParams);
	const pageStyle = backgroundColorOverride
		? { backgroundColor: backgroundColorOverride }
		: undefined;

	useExternalAssets(styles);

	// Show loading state while checking URL params
	if (isValidPage === null) {
		return (
			<StatusView
				containerClassName={styles.pageClassName}
				containerStyle={pageStyle}
				message=""
			/>
		);
	}

	// Show error page if URL params are invalid
	if (!isValidPage) {
		return (
			<StatusView
				containerClassName={styles.pageClassName}
				containerStyle={pageStyle}
				title="Page Not Found"
				description="This page does not exist or the link is invalid."
			/>
		);
	}

	return (
		<div
			className={`min-h-screen flex justify-center ${inIframe ? "px-0 pt-0" : "items-center px-4 pt-4"} ${styles.pageClassName}`}
			style={pageStyle}
		>
			<div className={`w-full ${inIframe ? "" : "max-w-sm"}`}>
				{logoUrl && <BrandLogo src={logoUrl} />}

				{submitted ? (
					<SuccessState
						accentColor={styles.successAccentColor}
						wasMessageSubmission={wasMessageSubmission}
					/>
				) : (
					<CallRequestForm
						formData={formData}
						styles={styles}
						headingText={headingOverride}
						isLoading={isLoading}
						error={error}
						onSubmit={onSubmit}
						onFieldChange={onFieldChange}
					/>
				)}
			</div>
		</div>
	);
}
